import { ApiClient } from './ApiClient';

export default class GroupTrackersConfigApiClient extends ApiClient {
  private readonly BASE_URL: string = '/api/group-trackers-config';

  public async getIsPublishedStatus(): Promise<boolean> {
    const response = await this.get(`${this.BASE_URL}/published-status`);
    return response.data;
  }

  public async getTemplateIsPublishedStatus(templateId: number): Promise<boolean> {
    const response = await this.get(`${this.BASE_URL}/templates-published-status?templateId=${templateId}`);
    return response.data;
  }

  public async publish(preview: boolean = false, groupHash: string = '') {
    return await this.post(`${this.BASE_URL}`, {
      gh: groupHash || this.getGroupHash(),
      preview,
    });
  }

  public async provideGroupHashesForUnpublishedTemplate(templateId: number): Promise<string[]> {
    const response = await this.get(`${this.BASE_URL}/all-unpublished-templates-group-hashes?templateId=${templateId}`);
    return response.data;
  }
}
